module.exports = __webpack_public_path__ + "img/payw.dc1c7495.png";